import React, { useState, useEffect } from 'react'

import { Container, CssBaseline, CircularProgress, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
	container: {
		position: 'fixed',
		top: 0,
		left: 0,
		backgroundColor: '#FFFFFF',
		opacity: '0.6',
		height: '100vh',
		zIndex: 10000
	},
	paper: {
		marginTop: '40vh',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center'
	}
}))

const Loading = (props) => {
	const classes = useStyles()
	const [progress, setProgress] = useState(0)

	useEffect(() => {
		const tick = () => {
			// reset when reaching 100%
			setProgress((oldProgress) => (oldProgress >= 100 ? 0 : oldProgress + 1))
		}

		const timer = setInterval(tick, 20)
		return () => {
			clearInterval(timer)
		}
	}, [])

	return (
		<Container className={classes.container} maxWidth={false}>
			<CssBaseline />
			<div className={classes.paper}>
				<CircularProgress variant="determinate" size="5rem" value={progress} />
			</div>
		</Container>
	)
}

export default Loading
